// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleMoreFrom_root__1nk4c","title":"ArticleMoreFrom_title__eRRY8","list":"ArticleMoreFrom_list__tWdYZ"};